import React from 'react';
import { LoadingContainer, LoadingSpinner } from './styles';

function Loading() {
  return (
    <LoadingContainer>
      <LoadingSpinner />
    </LoadingContainer>
  )
}

export default Loading;
